var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fcfcfc;opacity:0;}.b{fill:#fff;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.c{fill:#666;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 12,
    height: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.29 2.499)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.5,5c0,3.5-4.5,6.5-4.5,6.5S1.5,8.5,1.5,5a4.5,4.5,0,0,1,9,0Z",
    transform: "translate(-1.29 -2.499)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(3.21 1.001)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f2fbe9cc1d51cd44ca0a37469b20e4d1.svg";
export { ForwardRef as ReactComponent };